export function getReturnOfExpression(expression) {
    return null;
}
export var returntypeof = getReturnOfExpression;
//# sourceMappingURL=type-utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typesafe-actions/es5-module/type-utils.js
// module id = 1010
// module chunks = 9